import axios from "axios";
import { endpoints } from "../services/apiurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const register = (username, email, password) => {
    return axios.post(endpoints.login, {
        username,
        email,
        password,
    });
};

const login = async (username, password) => {
    try {
        const response = await axios.post(endpoints.login, {
            username,
            password,
        });

        if (response.data.status) {
            if (response.data.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data.data));
            }
            // Display toaster for successful login
            toast.success('Login successful', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            // Display toaster for unsuccessful login
            toast.error('Login failed', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        
        return response.data;
    } catch (error) {
        // Display toaster for error during login
        toast.error('An error occurred during login', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        return error;
    }
};

const logout = () => {
    localStorage.removeItem("user");
};
export default {
    register,
    login,
    logout,
};